/**
 * Route for `advertiser-manager`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserManagerPage } from "../features/advertiser-manager/AdvertiserManagerPage";

export const advertiserManagerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-manager",
	component: AdvertiserManagerPage,
});

export default advertiserManagerRoute;
